import { CmsPage } from "components/editor/CmsPage";
import { AboutLandingWrapper } from "./AboutUs.styles";

interface AboutUsPageProps {
  title: "about-us2";
}

const AboutUsPage = ({ title }: AboutUsPageProps) => {
  return (
    <AboutLandingWrapper>
      <CmsPage pageTitle={title} showBorder />
    </AboutLandingWrapper>
  );
};
export default AboutUsPage;
